<template>
    <button type="button" class="text-xs leading-6">
        <template v-for="country in platformCountries" :key="country.id">
            <div v-if="country.iso?.toLowerCase() === selectedCountry">
                <div class="flex align-middle items-center gap-2">
                    <MiscIcon
                        :name="`flag-${country.iso?.toLowerCase()}`"
                        size="xs"
                        class="inline-flex country-flag"
                    />
                    <span aria-hidden="true" class="uppercase text-xxs">{{selectedCountry}}</span>
                    <span v-if="textByCountry[country.id]" class="sr-only">
                        <span class=" [@media(min-width:420px)]:inline">{{ $t(textByCountry[country.id]!) }}</span> <span>{{ $t(`layout.language.switch.country-${country.iso}`) }}</span>
                    </span>
                    <span v-else class="sr-only">
                        <span class="[@media(min-width:420px)]:inline">{{ $t('layout.topBar.country.shipping.fallback') }}</span> <span>{{ $t(`layout.language.switch.country-${country.iso}`) }}</span>
                    </span>
                </div>
            </div>
        </template>
    </button>
</template>

<script setup lang="ts">
const { platformDefaults, platformCountries } = useRuntimeConfig().public
const selectedCountry = ref<string>()

const textByCountry: Record<string, string> = {
    '23f1e3a2eba64c5197e47e7e5e41e785': 'layout.topBar.country.shipping.switzerland'
}

onMounted(() => {
    selectedCountry.value = platformCountries.find((country) => {
        return country.id === platformDefaults.countryId
    })?.iso.toLowerCase()
})
</script>
